<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>NIRF</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>NAAC</li>
          <li>NIRF</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!-- Start EI area -->
  <div class="alumni-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="alumni-left-content">
            <div class="related-download">
              <ul>
                <li>
                  <a href="vf/documents/naac/others/nirf.pdf" target="_blank"><i class="flaticon-search"></i>Latest<span
                      style="float: right"><strong>Click Here</strong></span></a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6" style="display: none;">
          <div class="alumni-left-content">
            <div class="related-download">
              <ul>
                <li>
                  <router-link to="/ssrdcriteria2"><i class="flaticon-search"></i>Criteria-wise Metrics-2<span
                      style="float: right"><strong>Click Here</strong></span></router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End EI area -->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <a href="/newsletter" class="default-btn btn">Newsletter<i class="flaticon-next"></i></a>
          <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "nirf-documents",
};
</script>
